module.exports = __webpack_public_path__ + "img/user.4435d603.svg";